import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { CalendarHeader as StyledHeader } from "../styles/styles";

export interface CalendarHeaderProps {
    currentDate: Dayjs;
    onPrevMonth: () => void;
    onNextMonth: () => void;
}

export const CalendarHeader = ({ currentDate, onPrevMonth, onNextMonth }: CalendarHeaderProps) => (
    <StyledHeader direction="row" alignItems="center" >
        <Typography variant="subtitle1" minWidth="140px">
            {currentDate.format('MMMM YYYY')}
        </Typography>
        <IconButton onClick={onPrevMonth} size="small">
            <ChevronLeft />
        </IconButton>
        <IconButton onClick={onNextMonth} size="small">
            <ChevronRight />
        </IconButton>
    </StyledHeader>
); 